module.exports = __webpack_public_path__ + "media/images/emblems/Gsteigwiler-coat_of_arms-f84db4fa20537d895bf57cddbeeb5785.svg";